import { Box, Tooltip, Typography } from '@mui/material';

import { AnalysisStatus } from '../../../../../../../api/theHive/licensedCompanies/types';
import {
  IconCancelMS,
  IconCheckCircleMS,
  IconPendingMS,
} from '../../../../../../../constants/icons';

interface AnalysisStatusIconProps {
  status: AnalysisStatus;
}

const CONFIG: Record<
  Exclude<AnalysisStatus, 'na'>,
  { icon: JSX.Element; color: string; label: string }
> = {
  approved: {
    icon: IconCheckCircleMS,
    color: '#2E7D32',
    label: 'Todos os documentos aprovados',
  },
  rejected: {
    icon: IconCancelMS,
    color: '#C62828',
    label: 'Há documento reprovado',
  },
  pending: {
    icon: IconPendingMS,
    color: '#ED6C02',
    label: 'Há documento a analisar',
  },
};

export function AnalysisStatusIcon({
  status,
}: AnalysisStatusIconProps): JSX.Element {
  if (status === 'na') {
    return (
      <Tooltip title="Sem documentos neste eixo">
        <Typography color="text.secondary">—</Typography>
      </Tooltip>
    );
  }

  const { icon, color, label } = CONFIG[status];
  return (
    <Tooltip title={label}>
      <Box
        component="span"
        sx={{
          color,
          display: 'inline-flex',
          '& svg': { fontSize: 24 },
        }}
      >
        {icon}
      </Box>
    </Tooltip>
  );
}
